/* eslint-disable max-len */
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var EmailIcon = function EmailIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    "aria-hidden": "true",
    enableBackground: "new 0 0 90 90",
    viewBox: "0 0 90 90",
    role: "presentation",
    children: [/*#__PURE__*/_jsx("title", {
      children: "Email Icon"
    }), /*#__PURE__*/_jsxs("g", {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "4.89",
      children: [/*#__PURE__*/_jsx("path", {
        d: "m7.4 21.7h75.2c2.5 0 4.6 2 4.6 4.6v37.5c0 2.5-2 4.5-4.6 4.5h-75.2c-2.5 0-4.6-2-4.6-4.5v-37.6c0-2.5 2.1-4.5 4.6-4.5z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m4.8 22.8 38 21c1.4.8 3 .8 4.4 0l38.2-21.1"
      })]
    })]
  });
};

export default /*#__PURE__*/memo(EmailIcon);